import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  images: {
    width: "100%",
    padding: "0px 25px",
    height: "auto",
  },
  text: {
    color: "#fff",
  },
}));
